var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.08C11.7 22.08 11.4 22.01 11.15 21.87C9.28 20.85 5.99 19.77 3.93 19.5L3.64 19.46C2.33 19.3 1.25 18.07 1.25 16.74V4.66C1.25 3.87 1.56 3.15 2.13 2.63C2.7 2.11 3.44 1.86 4.22 1.93C6.42 2.1 9.74 3.2 11.62 4.38L11.86 4.52C11.93 4.56 12.08 4.56 12.14 4.53L12.3 4.43C14.18 3.25 17.5 2.13 19.71 1.94C19.73 1.94 19.81 1.94 19.83 1.94C20.56 1.87 21.31 2.13 21.87 2.65C22.44 3.17 22.75 3.89 22.75 4.68V16.75C22.75 18.09 21.67 19.31 20.35 19.47L20.02 19.51C17.96 19.78 14.66 20.87 12.83 21.88C12.59 22.02 12.3 22.08 12 22.08ZM3.98 3.42C3.66 3.42 3.37 3.53 3.14 3.74C2.89 3.97 2.75 4.3 2.75 4.66V16.74C2.75 17.33 3.26 17.9 3.83 17.98L4.13 18.02C6.38 18.32 9.83 19.45 11.83 20.54C11.92 20.58 12.05 20.59 12.1 20.57C14.1 19.46 17.57 18.32 19.83 18.02L20.17 17.98C20.74 17.91 21.25 17.33 21.25 16.74V4.67C21.25 4.3 21.11 3.98 20.86 3.74C20.6 3.51 20.27 3.4 19.9 3.42C19.88 3.42 19.8 3.42 19.78 3.42C17.87 3.59 14.79 4.62 13.11 5.67L12.95 5.78C12.4 6.12 11.62 6.12 11.09 5.79L10.85 5.65C9.14 4.6 6.06 3.58 4.1 3.42C4.06 3.42 4.02 3.42 3.98 3.42Z",
    fill: "#494C50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.24C11.59 21.24 11.25 20.9 11.25 20.49V5.49C11.25 5.08 11.59 4.74 12 4.74C12.41 4.74 12.75 5.08 12.75 5.49V20.49C12.75 20.91 12.41 21.24 12 21.24Z",
    fill: "#494C50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 9.24H5.5C5.09 9.24 4.75 8.9 4.75 8.49C4.75 8.08 5.09 7.74 5.5 7.74H7.75C8.16 7.74 8.5 8.08 8.5 8.49C8.5 8.9 8.16 9.24 7.75 9.24Z",
    fill: "#494C50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12.24H5.5C5.09 12.24 4.75 11.9 4.75 11.49C4.75 11.08 5.09 10.74 5.5 10.74H8.5C8.91 10.74 9.25 11.08 9.25 11.49C9.25 11.9 8.91 12.24 8.5 12.24Z",
    fill: "#494C50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.f20663b72c083f686e89bef0bce02a20.svg";
export { ForwardRef as ReactComponent };